import React from "react";

function Icon() {
  return (
    <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64.5 32C64.5 14.4 50.1 0 32.5 0C14.9 0 0.5 14.4 0.5 32C0.5 48 12.1 61.2 27.3 63.6V41.2H19.3V32H27.3V24.8C27.3 16.8 32.1 12.4 39.3 12.4C42.9 12.4 46.5 13.2 46.5 13.2V21.2H42.5C38.5 21.2 37.3 23.6 37.3 26V32H46.1L44.5 41.2H36.9V64C52.9 61.6 64.5 48 64.5 32Z" fill="white"/>
    </svg>
  );
}

export default Icon;